import Section from "../Section";
import Slider from '../global/Slider';

export default class Testimonial extends Section {
  constructor(theme, element, pageLoad) {
    super(theme, element, pageLoad);
    this.element = element;
    if (!this.element) return;

    const sliderElement = this.element.querySelector('.slider-homepage-testimonial');

    if (!sliderElement) return;

    this.hasSlides = sliderElement.querySelector('.slides');

    if (this.hasSlides) {
      this.slider = new Slider(theme, sliderElement);
      theme.testimonials = theme.testimonials || {};
      theme.testimonials[element.dataset.sliderId] = this.slider;
    }
  }

    onBlockSelect = ({ element }) => {
      const index = parseInt(element.dataset.slideIndex, 10);

      if (this.hasSlides) this.slider.showSlide(index);
    }

    onBlockDeselect = () => {
      if (this.hasSlides) this.slider.startAnimation();
    }
}
